import _isString from 'lodash/isString';
import _has from 'lodash/has';
import _isEmpty from 'lodash/isEmpty';
import _toNumber from 'lodash/toNumber';
import _find from 'lodash/find';

import Cookies from 'universal-cookie';
import { getContent } from 'pp-react-l10n';
import classNames from 'classnames';
import _filter from 'lodash/filter';
import _conforms from 'lodash/conforms';

import * as community from '../../data/community.json';
import * as machineTranslateText from '../../data/translation.json';
import { PageMapping } from './page-name-identifiers';
import * as links from '../../data/links.json';
import contentHelper from './contentHelper';
import { getQueryValue, getLastPathVariable } from './location-helper';
import { contactMapping } from './ContactDefaultData';
import { filterCallUsFromChannels, isSuppressCallUs } from './covidHelper';
import { isC2MerchantMigrated } from './globalHelper';
import UrlResources from '../home/constants/UrlResources';

const html = document.querySelector('html');
const cobrand = html.getAttribute('cobrand') || 'us';
const locale = html.getAttribute('lang') || 'en-US';
const language = html.getAttribute('language') || 'en';
const device = html.getAttribute('data-device-type');
const browserVersion = html.getAttribute('data-device-version');
const browserName = html.getAttribute('data-device-name');
const browserType = document.body.getAttribute('data-browser-type');
const isSmcEnabled = html.getAttribute('isSmcEnabled');
const pageName = html.getAttribute('page') || '';
const loginInfo = document.body.getAttribute('isloggedin');
const isIDIContactOptions = html.getAttribute('isIDIContactOptions');
const isTechnicalTabEnable = html.getAttribute('isTechnicalTabEnable');
const userExperience = html.getAttribute('experience');
const isBusinessUser = html.hasAttribute('is-business-user') || false;
const contentGlobalContainer = document.getElementsByClassName('vx_foreground-container');
const isToggleTreatment = html.hasAttribute('isToggleTreatment');
const regexMTS = /^(TS|ts)\d+$/;
const regexAnchor = /^#\w+$/;
const fromBusinessFooter = html.hasAttribute('is_from_business_footer');
const market = html.getAttribute('market');
const isTranslation = html.getAttribute('isMachine');
const isComplaintEnabledMarket = html.getAttribute('isComplaintEnabledMarket');
const USBusinessUser = html.getAttribute('isUSBusinessUser');
const direction = html.getAttribute('dir') || 'ltr';
const channel = html.getAttribute('channel');
const isRacEnabled = html.getAttribute('isRacEnabled');
const isContactUsLandingPageChatEligible = html.getAttribute('isContactUsLandingPageChatEligible');
const isContactUsFinalIntentChatEligible = html.getAttribute('isContactUsFinalIntentChatEligible');
const isResKeywordTitleEnable = html.getAttribute('isResKeywordTitleEnable');
const isHardcodeGroupEmailForm = html.hasAttribute('is_hardcode_group_email_form');
const isChatbotMobileTabletDisable = html.hasAttribute('chatbot_mobile_tablet_disable');
const isIDIenableForRAC = html.hasAttribute('IDIenabledForRAC') || false;
const isMobileauthwebStepupEnabledCountries = html.hasAttribute('isMobileauthwebStepupEnabledCountries') || false;
const isCustomWebPinTooltipEnabled = html.getAttribute('isCustomWebPinTooltipEnabled');
const isContactOptionsForceIntent = html.hasAttribute('is_contact_options_force_intent');
const isFundsNowInstantAvailable = html.getAttribute('isFundsNowInstantAvailable');

const communityChannel = 'COMMUNITY';
const contactQuery = 'contact';

const cookies = new Cookies();

function warn(message) {
  console.error(`☃ ${message}`); // eslint-disable-line no-console
}

// Check basic elements required for the app
// (function pageInitCheck() {
//   // locale bundle
//   if (!window.localeBundle) {
//     warn('Missing locale bundle!');
//   }
//
//   // user profile
//   if (!window.userProfile) {
//     warn('Missing user profile!');
//   }
// }());

const Page = {
  checkPageInPath(path) {
    // hard code route path for check
    // Check home route
    const validatePages = ['home'];
    let validPath = false;
    validatePages.forEach((page) => {
      if (path.indexOf(page) >= 0) {
        validPath = true;
      }
    });
    return validPath;
  },

  getCountry() {
    return cobrand;
  },

  getBaseUrl() {
    if (window.location.href.includes('localhost')) {
      return `https://${window.location.host}`;
    }
    return `https://${window.location.hostname}`;
  },

  getArticleId() {
    if (!Page.isArticlePage()) {
      return '';
    }

    const pathName = window.location.pathname;
    const article = (typeof pathName === 'string' && pathName.split('/').pop());

    if (typeof article !== 'string' || !article) {
      return '';
    }

    const articleInfo = article.split('-');
    return articleInfo.pop();
  },

  getArticleIdLowerCase() {
    return Page.getArticleId() && Page.getArticleId().toLowerCase();
  },

  isHomePage() {
    return (pageName === 'home');
  },

  isArticlePage() {
    return (pageName === 'article');
  },

  isContactUsPage() {
    return (pageName === 'contact-us');
  },

  // icf Page
  isIcfGuidePage() {
    return (pageName === 'PAYPAL_HELP_GUIDE');
  },

  isIcfTopicsPage() {
    const pathName = window.location.pathname;
    return pathName.endsWith(UrlResources.PAYPALGUIDE);
  },

  getPageName() {
    return pageName;
  },

  getMachineTranslationMarket() {
    return market;
  },

  isMachineTranslation() {
    return isTranslation && Page.isLoggedIn();
  },

  isMPPEnable() {
    return window.mppEnable;
  },

  isAnchorLink(link) {
    return regexAnchor.test(link);
  },

  getCookie(name) {
    return cookies.get(name);
  },

  setCookie(name, value, cookieOptions) {
    const options = { ...cookieOptions };

    // We only set the httpOnly and secure attributes to `true` on https enabled sites. (Our local stages' httpS is not configured correctly so we skip it)
    const secureHTTPOnlyBool = (Page.getCurrentEnvironment() === 'production')
      && (Page.getCurrentPageProtocol() === 'https')
      && window.location.href.indexOf('smarthelpnodeweb') < 0;

    // Let's make sure that these properties `secure`, `httpOnly` are both set manually so they don't get overwritten.
    options.secure = secureHTTPOnlyBool;
    options.httpOnly = secureHTTPOnlyBool;

    cookies.set(name, value, options);
  },

  getCurrentEnvironment() {
    return process.env.NODE_ENV;
  },

  getCurrentPageProtocol() {
    return (window.location.protocol || 'http:').split(':')[0];
  },

  getLocaleContent(file) {
    const content = window.localeBundle && window.localeBundle[`smarthelp/${file}`];

    if (!content) {
      warn(`Property file smarthelp/${file} missing`);
    }
    return content;
  },

  getLocaleJson() {
    return window.localeBundle;
  },

  // Get 'lang' from HTML
  getLocale() {
    return locale;
  },

  // Getting the service locale
  getAPILocalilty() {
    return html.getAttribute('locale');
  },

  getLanguage() {
    return language;
  },

  getChannel(channelOption) {
    const channelTmp = channelOption || channel;
    if (Page.getEligibleFilters().indexOf(channelTmp) >= 0) {
      return channelTmp;
    }
    return 'faq';
  },

  getUserProfile() {
    return window.userProfile;
  },

  getExpByUserType() {
    return userExperience || ((isBusinessUser) ? 'business' : 'personal');
  },

  getBaseURLWithExperience() {
    return `${cobrand}/smarthelp`;
  },

  getIsSmcEnabled() {
    return isSmcEnabled === 'true';
  },

  isRacEnabled() {
    return isRacEnabled === 'true';
  },

  isContactUsLandingPageChatEligible() {
    return isContactUsLandingPageChatEligible === 'true';
  },

  isContactUsFinalIntentChatEligible() {
    return isContactUsFinalIntentChatEligible === 'true';
  },

  getIsIDIContactOptions() {
    return isIDIContactOptions === 'true';
  },

  getDirection() {
    return direction;
  },

  getArrowDirectionStyle() {
    return Page.getDirection() === 'ltr' ? 'icon-arrow-right-small' : 'icon-arrow-left-small';
  },

  getBackArrowDirectionStyle() {
    return Page.getDirection() === 'ltr' ? 'cw_icon cw_icon-small cw_icon-arrow-back-small browser-back-arrow' : 'browser-back-arrow__RTL';
  },

  getResolutionURL() {
    return contentHelper(links.resolutionCenter, { originURL: encodeURIComponent(Page.getOriginPath()) });
  },
  isNotIEbrowser() {
    return !(browserType === 'IE');
  },

  isToggleTreatment() {
    return isToggleTreatment;
  },
  getIsBusinessUser() {
    return isBusinessUser;
  },
  isUSBusinessUser() {
    return USBusinessUser;
  },
  isResTitleEnable() {
    return isResKeywordTitleEnable === 'true';
  },

  isMobileLayout() {
    return device === 'mobile';
  },

  isTabletLayout() {
    return device === 'tablet';
  },
  isXsLayout() {
    return document.body.clientWidth <= 768;
  },
  isMobileModal() {
    return (this.isMobileLayout() || this.isTabletLayout()) && this.isXsLayout();
  },

  isDesktopLayout() {
    return device === 'desktop';
  },

  getBrowserVersion() {
    return browserVersion;
  },

  getBrowserName() {
    return browserName;
  },

  isMTSArticle(articleId) {
    return regexMTS.test(articleId);
  },

  isLoggedIn() {
    return loginInfo;
  },

  getFPTILogin() {
    return Page.isLoggedIn() ? 'in' : 'out';
  },

  // For PPC logout part checker
  isLogoutUS() {
    return this.getCountry() === 'us' && !this.isLoggedIn();
  },

  isNoExtraSpaceLocale() {
    return Page.getLocale().indexOf('zh') >= 0 || (Page.getLocale().indexOf('de') >= 0 && Page.isMobileLayout());
  },

  isNoLoginRequire(refID) {
    if (window.emeaLoggedOutIntent && Array.isArray(window.emeaLoggedOutIntent.loggedOutIntent) && window.emeaLoggedOutIntent.loggedOutIntent.length > 0
     && window.emeaLoggedOutIntent.loggedOutIntent.includes(refID)) {
      return true;
    }
    return false;
  },

  getCSRFtoken() {
    return document.body.getAttribute('data-token');
  },

  getDeviceType() {
    return document.body.getAttribute('data-device-type');
  },

  // TODO: We are formatting the title and append the article id later in all the palces where this function is used
  //       So we can simply refactor this code and use getFormattedUrlForArticle passing both articleTitle and articleId
  getFaqUrlFromTitle(title) {
    return encodeURIComponent(title && title.replace(/ /g, '-').replace(/\?/g, '').replace(/[/\\]/g, '-').toLowerCase());
  },

  getFormattedUrlForArticle(title, articleId) {
    return decodeURIComponent(`${this.getFaqUrlFromTitle(title)}-${articleId.toLowerCase()}`);
  },

  getFullArticleURL(currentArticle) {
    return currentArticle && currentArticle.articleId
      ? `/${this.getBaseURLWithExperience()}/article/${this.getFormattedUrlForArticle(currentArticle.articleTitle, currentArticle.articleId)}`
      : '';
  },

  // Get HCR Home page URL
  getHomeURL() {
    return `/${this.getBaseURLWithExperience()}/home`;
  },

  // Get HCR Topic page URL
  getTopicURL(topic) {
    return (topic && topic.topicId)
      ? `/${this.getBaseURLWithExperience()}/topic/${topic.topicId}` : '';
  },

  getUserExperience() {
    return userExperience;
  },

  isTechnicalExp() {
    return Page.getUserExperience() === 'technical';
  },

  // Using remote config to control UI technical tab/exp
  hasTechnicalTab() {
    return isTechnicalTabEnable === 'true';
  },

  isComplaintEnabledMarket() {
    return isComplaintEnabledMarket;
  },

  getPathName() {
    return window.location.pathname;
  },

  getCurrentURI() {
    const pathname = encodeURIComponent(Page.getPathName().slice(3));
    const originPath = Page.getOriginPath();
    return `${originPath}${pathname}`;
  },

  goTo(url) {
    const referLink = document.createElement('a');
    referLink.href = url;
    document.body.appendChild(referLink);
    referLink.click();
  },

  getCommunityLocale() {
    if (locale === 'pt-PT' || locale === 'es-ES') { // No community links for these locales
      return locale;
    }
    return `${Page.getLanguage()}`;
  },

  getCommunityLink() {
    if (this.isTechnicalExp()) {
      return community.community.technical;
    }

    return community.community[Page.getCommunityLocale()] ? `${community.community[Page.getCommunityLocale()]}?country.x=${cobrand}` : null;
  },

  // Machine Translation Error message
  getTranslationError(loc) {
    if (!loc) {
      return null;
    }
    return machineTranslateText.error[loc];
  },

  // Machine Translation button text
  getTranslation(loc) {
    if (loc) {
      const reqCountry = Page.getCountry().toUpperCase();
      return machineTranslateText.machineTranslate[reqCountry] && machineTranslateText.machineTranslate[reqCountry][loc];
    }
    return null;
  },

  // Machine Translation tooltip message
  getTooltip(loc) {
    if (loc) {
      return machineTranslateText.tooltipMsg[loc];
    }
    return null;
  },

  getCommunitySearchURL() {
    const validMarket = Object.keys(community.community);
    if (validMarket.indexOf(Page.getCommunityLocale()) >= 0) {
      return community.searchURL;
    }
    return null;
  },

  getGlobalContainer() {
    return contentGlobalContainer;
  },

  getTreatments() {
    return window.applicableTreatments;
  },

  getDisputeHelpList() {
    return window.disputeHelpList;
  },

  // check for articles in dispute articles remote config
  disputeArticle(article) {
    const id = (article || '').toLowerCase();
    return Array.isArray(window.disputeHelpFaq) && window.disputeHelpFaq.indexOf(id) >= 0;
  },

  // Check breadcrumb path in the article content and display dispute transactions
  disputeBreadCrumb(path) {
    const list = Page.getDisputeHelpList();
    return typeof path === 'string' && Array.isArray(list) && list.some((topic) => path.indexOf(topic) >= 0);
  },

  getEligibleFilters() {
    return window.eligibleFilters;
  },

  getOriginPath() {
    return `${window.location.protocol}//${window.location.host}`;
  },

  getHashPath() {
    return (window.location.hash || '').slice(1);
  },

  setDocumentTitle(title) {
    window.document.title = title;
  },
  setCanonicalTag(options) {
    // avoid duplicate canonical URL's & update the href 1 : 1 mapping
    const allElem = document.getElementsByTagName('link');
    for (let i = 0; i < allElem.length; i += 1) {
      if (allElem[i].getAttribute('rel') === 'canonical') {
        if (options.name === 'home') {
          allElem[i].setAttribute('href', this.getHomePageUrlForSelfhelp());
          return;
        } if (options.name === 'article') {
          allElem[i].setAttribute('href', this.getArticleUrlForSelfhelp(options.id, options.title));
          return;
        }
      }
    }
    // construct the helpcenter URL based on home / article page.
    const url = options.name === 'home' ? this.getHomePageUrlForSelfhelp() : this.getArticleUrlForSelfhelp(options.id, options.title);
    const canonicalTag = document.createElement('link');
    canonicalTag.rel = 'canonical';
    canonicalTag.href = url;
    document.getElementsByTagName('head')[0].appendChild(canonicalTag);
  },
  // function to create the article URL to match the existing helpcenter for SEO purpose
  getArticleUrlForSelfhelp(faqId, title) {
    const origin = this.getOriginPath();
    const faqLowercase = faqId && faqId.toLowerCase();
    const replaceTitle = title ? `${this.getFaqUrlFromTitle(title)}-` : '';
    const baseUrl = `${origin}/${cobrand}/smarthelp/article/${replaceTitle}${faqLowercase}`;
    return baseUrl;
  },
  getHomePageUrlForSelfhelp() {
    const origin = this.getOriginPath();
    return `${origin}/${cobrand}/smarthelp/home`;
  },

  // TODO: add rank into the article link
  getArticleLink(faqId, faqTitle = '') {
    const country = this.getCountry();
    const articleTitle = faqTitle ? `${this.getFaqUrlFromTitle(faqTitle)}-` : '';
    return decodeURIComponent(`/${country}/smarthelp/article/${articleTitle}${faqId.toLowerCase()}`);
  },

  getSanitizedValue(value) {
    const returnValue = value ? value.trim() : '';
    try {
      return encodeURIComponent(returnValue);
    } catch (error) {
      return returnValue;
    }
  },

  // Get FPTI page name id by path mapping the indentifer file
  getFPTIPageId() {
    let tempPath = '';
    const locationPath = window.location && window.location.pathname;
    if (locationPath && _isString(locationPath)) {
      const temp = locationPath.split('/'); // Split path by '/'
      if (Array.isArray(temp) && _has(PageMapping, temp[3])) {
        tempPath = temp[3];
      }
    }
    return PageMapping[tempPath] || 'homePage';
  },

  isTopicTreeDisabled() {
    return (document.querySelector('html') && document.querySelector('html').hasAttribute('topic_tree_disabled')) || false;
  },

  // Using L10N html to replace dangerouslySetInnerHTML
  getHTMLElement(options) {
    return getContent({
      content: {
        innerMessage: options.message,
      },
      path: 'innerMessage',
      useHTML: options.useHTML || false,
    });
  },

  // Scroll Screan View for fixed header
  scrollDown(headerHeigh = 75) {
    const scrolledY = window.scrollY;
    if (scrolledY) {
      window.scroll(0, scrolledY - headerHeigh);
    }
  },

  scrollToTop() {
    setTimeout(() => {
      window.scroll(0, 0);
    }, 0);
  },
  /**
   * Setting home page redirect URL with user selected Exp query
   * options: {
   *  path,
   *  search,
   *  experience,
   * }
   */
  getSelectedExpURL(options) {
    // TODO: keep search query
    return `${options.path}?selectedExp=${options.experience}`;
  },

  formalQuickAnswerKey({ layer, topicId }) {
    return `${layer}|${topicId}`;
  },

  isContactOptionsForBusinessUsers() {
    return isBusinessUser && fromBusinessFooter;
  },
  /**
   * show Contact options (Adding Force intent logic):
   * 1. Logout users
   * 2. Login users whose country is not in the contact_options_force_intent remote config
   * 3. If user is logged in and clicks on contacts us link in footer
   * @return Boolean   default display contact option
   */
  isValidToDisplayContactOptions() {
    return !Page.isLoggedIn() || !isContactOptionsForceIntent || (Page.isLoggedIn() && Page.checkContactOptionsFlag());
  },

  checkContactOptionsFlag() {
    return window.sessionStorage.getItem('showContactOptions') === 'true';
  },

  getEmailThankYouPageDescription(topicRefId, selectedTopicDetails) {
    if (this.isComplaintEnabledMarket() && this.getIsSmcEnabled() && topicRefId === 'formal_complaints_l1') {
      return 'emailSentNotesForComplaintMarkets';
    } if (this.isComplaintEnabledMarket() && topicRefId === 'formal_complaints_l1' && !this.getIsSmcEnabled()) {
      return 'nonSmcEmailSentNotesForComplaintMarkets';
    } if (selectedTopicDetails && typeof selectedTopicDetails.kanaCode === 'string' && selectedTopicDetails.kanaCode.trim() === 'PAYPALME001') {
      return 'emailSentAdditionalResourcesNotes';
    } if (selectedTopicDetails && typeof selectedTopicDetails.kanaCode === 'string' && selectedTopicDetails.kanaCode.trim() === 'PPGF001') {
      return 'ppgfEmailSentNotes';
    } if (!this.isComplaintEnabledMarket() && this.getIsSmcEnabled()) {
      return 'emailSentNotes';
    }
    return 'nonSmcEmailSentNotes';
  },

  URLReplacement(url, name, value) {
    if (!url) return '';

    const queryName = name.replace(/[[\]]/g, '\\$&');

    // exist any query, then check target query by its name
    const regexQueryValue = new RegExp(`[?&]${queryName}(=([^&#]*)|&|#|$)`);
    const results = regexQueryValue.exec(url);

    try {
      if (regexQueryValue.test(url) && Array.isArray(results) && results.length > 0) {
        const replacement = `${queryName}=${encodeURIComponent(value)}`;
        return url.replace(`${queryName}${results[1]}`, replacement);
      }
      return `${url}&${queryName}=${encodeURIComponent(value)}`;
    } catch (e) {
      console.warn('URLReplacement error'); // eslint-disable-line no-console
      return url;
    }
  },

  /**
   * Update/Add query base ame and value in to URL
   * @param {string} url    origin/target URL
   * @param {string} name   query name
   * @param {string} value  query value
   * @return {string}       Update URL
   */
  setURLQuery(url, name, value) {
    if (!url) return '';

    const queryName = name.replace(/[[\]]/g, '\\$&');

    // Check Query exist or not
    const regexQueryChecker = new RegExp('[?]([a-zA-z0-9]+)(=([^&#]*)|&|#|$)');

    if (regexQueryChecker.test(url)) {
      // exist any query, then check target query by its name
      const regexQueryValue = new RegExp(`[?&]${queryName}(=([^&#]*)|&|#|$)`);
      const results = regexQueryValue.exec(url);

      if (regexQueryValue.test(url) && Array.isArray(results) && results.length > 0) {
        const replacement = `${queryName}=${value}`;
        return url.replace(`${queryName}${results[1]}`, replacement);
      }
      return `${url}&${queryName}=${value}`;
    }
    // no query
    return `${url}?${queryName}=${value}`;
  },

  // logout email string data: 'key1:value1, key2:value2, ...'
  getLogoutEmail() {
    return window.logoutEmail;
  },

  // form object based on remote config data of Logout Email form
  getKeyValuePair(remoteString) {
    if (typeof remoteString !== 'string' || !remoteString) {
      return null;
    }

    const mapping = {};
    // remove white space and form key value pair
    const pairs = remoteString.trim().replace(/\s/g, '').split(',');
    pairs.forEach((pair) => {
      if (typeof pair === 'string') {
        const map = pair.split(':');
        if (Array.isArray(map) && map.length === 2) {
          mapping[map[0]] = map[1];
        }
      }
    });

    return mapping;
  },

  getLogoutEmailRefId() {
    const queryValue = getLastPathVariable(window.location);
    const emailRefMapping = Page.getKeyValuePair(Page.getLogoutEmail());
    if (!queryValue || _isEmpty(emailRefMapping) || !emailRefMapping[queryValue]) {
      return null;
    }
    return emailRefMapping[queryValue];
  },

  // ChatBot Query Chechker
  getChatBotContactTo() {
    return getQueryValue(Page.getContactQuery(), window.location);
  },

  getQueryParamValue(queryName) {
    return getQueryValue(queryName, window.location);
  },

  getContactQuery() {
    return contactQuery;
  },
  // Set `mts` value to `channel` query into URL
  setChannelForTechnicalExp(url) {
    const CHANNEL = 'channel';
    const TECHNICALEXP = 'mts';

    if (Page.isTechnicalExp()) {
      return Page.setURLQuery(url, CHANNEL, TECHNICALEXP);
    }

    return `${url}`;
  },
  isEmailNotSent() {
    return decodeURIComponent(window.location.search.replace(new RegExp(`^(?:.*[&\\?]${encodeURIComponent('emailSent').replace(/[.+*]/g, '\\$&')}(?:\\=([^&]*))?)?.*$`, 'i'), '$1')) === 'false';
  },
  // Checking dispute article based on title Keyword
  isDisputeArticle(articleTitle) {
    // TODO: Update Keyword rule for different language support
    const disputeReg = /claim|dispute|resolution/i;
    return articleTitle ? disputeReg.test(articleTitle) : false;
  },

  // Disable Chat Bot/Chat for mobile and tablet controlled by remote config
  isChatMobileTabletDisable() {
    return isChatbotMobileTabletDisable;
  },

  isIDIenableForRAC() {
    return isIDIenableForRAC;
  },

  isMobileauthwebStepupEnabledCountries() {
    return isMobileauthwebStepupEnabledCountries;
  },

  disableChatbotInMobileTablet() {
    return (Page.isMobileLayout() || Page.isTabletLayout()) && Page.isChatMobileTabletDisable();
  },

  isSearchTopicDisplay() {
    return pageName === 'contact-us';
  },

  getSearchTopicClassName(styleName) {
    return classNames({
      [styleName]: true,
      [`${styleName}__search_tree`]: true,
    });
  },

  isUsingHardcodeEmailForm() {
    return isHardcodeGroupEmailForm;
  },

  isCommunityChannel(itemChannel) {
    return itemChannel === communityChannel;
  },

  showMobileTableLiveChat() {
    return (Page.isMobileLayout() || Page.isTabletLayout()) && !Page.isChatMobileTabletDisable();
  },

  // Check Chat option in the Contact options
  hasChatOptions(options) {
    return Array.isArray(options) && options.some((option) => option.type === 'chat');
  },

  checkIsCustomWebPinTooltipEnabled() {
    return isCustomWebPinTooltipEnabled;
  },

  webformNameReconstuctor(name) {
    if (typeof name !== 'string') {
      return null;
    }
    const tempName = name.toLowerCase().replace(/ /g, '_');
    if (tempName === 'transaction_id') {
      return 'SmcTransactionNumber';
    } if (tempName === 'case_or_claim_or_dispute_id') {
      return 'SmcCaseNumber';
    }
    return tempName;
  },

  getCurrentLocationURL() {
    return window.location.href;
  },

  getHardcodePrivacyEmailForm(searchPool) {
    // Hard code Privacy Email form identifiers
    const enumtemplate = '27001';
    const inumtemplate = '17001';
    const searchResult = searchPool.filter((pool) => pool.web_forms && pool.web_forms.kana && pool.web_forms.kana.enumtemplate === enumtemplate && pool.web_forms.kana.inumtemplate === inumtemplate);

    return Array.isArray(searchResult) ? searchResult[0] : null;
  },

  removeSession(key) {
    sessionStorage.removeItem(key); // Purging session variable to hide contact options
  },

  // Polling FPTI and validate it
  validateFpti() {
    if (!window.fpti) {
      return Promise.reject();
    }
    return Promise.resolve();
  },

  getHCRHomeURL() {
    return `/${cobrand}/smarthelp/home`;
  },

  isChromeBrowser() {
    return typeof browserName === 'string' && browserName.indexOf('Chrome') >= 0;
  },

  // check and get SpeechRecognition object for Chrome browser
  getSpeechRecognition() {
    return window.SpeechRecognition || window.webkitSpeechRecognition;
  },

  isShowSpeechRecognition() {
    return html.hasAttribute('speech_to_text') && Page.isChromeBrowser();
  },

  isBrcEnabledMarket() {
    return html.getAttribute('isBrcEnabledMarket') === 'true';
  },

  getFptiIdForChatLoadError() {
    let response = null;

    if (Page.isArticlePage()) {
      response = 'chatBotArticleError';
    } else if (Page.isContactUsPage()) {
      response = 'chatBotContactUsError';
    } else if (Page.isHomePage()) {
      response = 'chatBotHomeError';
    }

    return response;
  },

  isPilotUser() {
    return html.hasAttribute('is_pilot_user');
  },

  getPilotWaitTime() {
    return html.getAttribute('message_wait_time');
  },

  getChatBotEligibilityParams(intent, intentType) {
    const path = ((window.location || {}).pathname || '').split('/').pop() || null;
    const intentId = intent || path;
    return ({
      intentId,
      intentType,
      entryPoint: path,
    });
  },

  // if the user is SMC remote config enable and SMC login users
  isRedirectToSMC() {
    return Page.getIsSmcEnabled();
  },
  redirectToSMC() {
    return window.open('/smc/customer?isModal=true', '_self');
  },

  isLexaPilotFailure() {
    return html.hasAttribute('lexa_pilot_error');
  },

  getUserFirstName() {
    return window.userProfile && typeof window.userProfile === 'object' && window.userProfile.firstName;
  },

  isAUPHardcodeFormEnabled() {
    return Page.getLogoutEmailRefId() === 'PAYPALME001';
  },

  isFundsNowInstantAvailable() {
    return isFundsNowInstantAvailable === 'true';
  },

  validateIsRedirectedFromAnw() {
    const queryValue = getQueryValue('anwRedirect', window.location);
    return queryValue === 'true';
  },

  // get contact option for login async user
  getIDIContactOptions() {
    return window.contactChannels;
  },

  // get contact option for login async user
  getIDIContactOptionDecisions() {
    return window.channelDecisions;
  },

  // Get the decision of default Chat option from Lexa service
  getDefaultChatDecision() {
    return _find(window.channelDecisions, (decision) => decision && decision.name === 'CHAT');
  },

  isRacAvaibleInChannelDecsions() {
    return _find(window.channelDecisions, (decision) => decision && decision.name === 'RAC');
  },
  isRacAvaibleInContactChannels(channels) {
    return _find(channels, (decision) => decision && decision.name === 'RAC');
  },
  validateAnwIsRedirectError() {
    return getQueryValue('failedBecause', window.location) === 'service_error';
  },

  isDisplayAuthPrompt() {
    return html.getAttribute('showLoginConfirmStepUp') === 'true' && loginInfo; // update prompt auth check logic
  },

  getStepupUUID() {
    return html.getAttribute('confirmloginstepupid') || '';
  },

  isMobileWebCallUsLinkEnabled() {
    return html.hasAttribute('isMobileWebCallUsLinkEnabled');
  },

  // parsing the default contact channels
  joinContactOptions(contactChannels = []) {
    if (!Array.isArray(contactChannels)) {
      return '';
    }

    let filteredChannels = [];

    // COVID-19 BCP suppress callUS from FPTI
    if (Page.isLoggedIn() && !Page.getIsIDIContactOptions() && isSuppressCallUs()) {
      filteredChannels = filterCallUsFromChannels(contactChannels);
    } else {
      filteredChannels = contactChannels;
    }

    filteredChannels = _filter(filteredChannels,
      _conforms({
        type: (type) => ((Page.getCommunityLink() && Page.getCommunitySearchURL()) || type !== 'community'), // Community filter logic
      }));

    // sorting channels based on priority
    const tmpChannels = [...filteredChannels].sort((channel1, channel2) => (
      _toNumber(channel1.priority) - _toNumber(channel2.priority)
    ));

    let tempChannelsArr = tmpChannels.map((contactType) => {
      const temp = ((contactType && contactType.type) || '').toLocaleLowerCase();

      // Mapping contact options
      return contactMapping[temp];
    });

    const defaultChatDecision = Page.getDefaultChatDecision();
    if (tempChannelsArr.indexOf(contactMapping.message) === -1 && defaultChatDecision && defaultChatDecision.availability_decision === 'DELAYED_AVAILABLE' && !isC2MerchantMigrated()) {
      // pushing livechatgreyout only if disablechaticon remote config is true and message-us option doesn't exist and if user is not c2merchantmigrated
      tempChannelsArr = tempChannelsArr.filter((tmpChannel) => tmpChannel !== 'chat'); // use grey out chat to place the chat option
      tempChannelsArr.push('liveChatGrayedOut');
    }
    return tempChannelsArr.join('|');
  },

  isunSupportedBrowser() {
    // Unsupportedbrowser for Dispute tracker
    return html.hasAttribute('unSupportedBrowser');
  },

  elmoTreatments() {
    return window.elmoTreatments;
  },

  getIcfConfig() {
    return window.icfConfig;
  },

  getIcfId(pathName) {
    const pathArray = pathName && pathName.split('/');
    const icfId = (pathArray && pathArray.pop().toUpperCase()) || '';

    if (typeof icfId !== 'string' || !icfId) {
      return '';
    }

    const icfInfo = icfId.split('-');
    return icfInfo.pop();
  },

  getIsMarketEnabledForSeoTitle() {
    return html.getAttribute('isMarketEnabledForSeoTitle') === 'true';
  },
  /**
   * Faq in dispute alert
   * @returns {string}
   */
  getDisputeFaq() {
    return window.disputeFaq;
  },

  /**
   * Returns whether market is enabled for ppcredit tab
   * @returns {boolean}
   */
  getIsMarketEnabledForPPCreditTab() {
    return html.hasAttribute('isPPCreditTabEnabled');
  },

  /**
   *  BCP COVID-19 Non IDI enabled markets to suppress callUs option.
   * @returns {boolean}
   */
  getIsBcpNonIdiEnabledMarket() {
    return html.hasAttribute('isBcpNonIdiEnabledMarket');
  },

  /**
   *  EMEA Countries for callus option without login
   * @returns {boolean}
   */
  isEmeaMarket() {
    if (window.emeaLoggedOutIntent) {
      return window.emeaLoggedOutIntent.emeaMarkets;
    }
    return false;
  },

  /**
   * Search input limiter from RC - Default set at 60 chars
   */
  searchInputMaxString() {
    if (window.searchInputMaxLength) {
      return window.searchInputMaxLength;
    }
    return '';
  },

  /** get webform faq topic mapping
   *
   */
  getWebformFaqTopic() {
    return window.webformFaqTopicConfig;
  },
};

export default Page;
